import { Card, CardContent, CardHeader, Divider } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useUpdateClientParameter } from '../../../sic-lib/api/hooks/useUserConfig';

interface Props {
    notification: boolean;
    isRefreshingClientParameters: boolean;
}

export default function NotificationSettings({
    notification,
    isRefreshingClientParameters,
}: Props) {
    const { classes } = useStyles();

    const { mutate: updateParameter, isLoading: updateLoading } = useUpdateClientParameter();

    const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        updateParameter({
            name: 'EnablePushNotifications',
            value: notification ? '0' : '1',
        });
    };

    return (
        <Card>
            <CardHeader title="Push Notification Settings" />
            <Divider />
            <CardContent>
                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                    <Typography component="p" variant="body2">
                        Disable/Enable Push Notification:
                    </Typography>
                    <Grid
                        item
                        xs
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                    >
                        <Tooltip title={notification ? 'Disable' : 'Enable'}>
                            <Switch
                                checked={notification}
                                onChange={handleChange}
                                disabled={isRefreshingClientParameters || updateLoading}
                            />
                        </Tooltip>
                        <Typography component="p" variant="body2">
                            {notification ? 'Enabled' : 'Disabled'}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
